import React, { useState } from 'react';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { history } from '@umijs/max';
import styles from './index.less';

interface HeaderSearchProps {
  className?: string;
}

const HeaderSearch: React.FC<HeaderSearchProps> = ({ className }) => {
  const [searchValue, setSearchValue] = useState('');

  const handleSearch = (value: string) => {
    if (value.trim()) {
      // Navigate to search results page with the search query
      history.push(`/tenant/search?q=${encodeURIComponent(value.trim())}`);
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSearch(searchValue);
    }
  };

  return (
    <div className={`${styles.headerSearch} ${className || ''}`}>
      <Input
        placeholder="Search customers and dispatches..."
        prefix={<SearchOutlined />}
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        onPressEnter={() => handleSearch(searchValue)}
        onKeyPress={handleKeyPress}
        style={{
          width: 220,
        }}
      />
    </div>
  );
};

export default HeaderSearch;
